export default __webpack_public_path__ + "static/media/favicon.d9905dd2.ico";